const init = () => {
	const header = document.querySelector('header.wp-header');

	const currentScrollAmount = () => {
		return document.documentElement.scrollTop;
	};

	currentScrollAmount() > 25
		? header.classList.add('shadow')
		: header.classList.remove('shadow');

	document.addEventListener('scroll', () => {
		currentScrollAmount() > 25
			? header.classList.add('shadow')
			: header.classList.remove('shadow');
	});
};

if (document.readyState !== 'loading') {
	init();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		init();
	});
}
